import { render, staticRenderFns } from "./AdminEditCourse.vue?vue&type=template&id=b8c3ae98&scoped=true"
import script from "./AdminEditCourse.vue?vue&type=script&lang=js"
export * from "./AdminEditCourse.vue?vue&type=script&lang=js"
import style0 from "./AdminEditCourse.vue?vue&type=style&index=0&id=b8c3ae98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c3ae98",
  null
  
)

export default component.exports